export default {
  we_unite_the__: "我们把整个网络生态整合成一个高活跃度社区，精准引导你找到最适合自己目标的路径。".toUpperCase(),
  learn_more__: "БОЛЬШЕ О Vision".toUpperCase(),
  we_are_putting__: "我们打造的社区不怕封、不怕删，谁都动不了。".toUpperCase(),
  this_is_the__: "这就是你从未见过的下一代超级目录。".toUpperCase(),
  featured_vlogs: "热门视频专栏".toUpperCase(),
  featuring_real__: "实时评分、深度解析、独家爆料、全天候在线客服，每日更新不停歇。".toUpperCase(),
};
